var App = App || {};

App.StepSlider = (function ($) {
	"use strict";

	var Bps = ["xs", "sm", "md"],
		Bp = ZAGFramework.GetCurrentBP();
	const activeClass = "active-step";
	const completedClass = "completed-step";
	function init() {
		const stepSliderBlock = $(".block.block-step-slider");

		if (stepSliderBlock.length) {
			stepSliderBlock.each(function () {
				var thisStepSlider = $(this);
				var desktopSteps = thisStepSlider.find(".steps.desktop .step");

				MoveBarTo(thisStepSlider, $(desktopSteps[0])); //activate first step on init without scroll

				var nextButtons = thisStepSlider.find(".btn-next");
				var prevButtons = thisStepSlider.find(".btn-back");

				nextButtons.on("click", function () {
					Bp = ZAGFramework.GetCurrentBP();
					if (!Bps.includes(Bp)) {
						var currentStepId = $(this).closest(".active-step").attr("data-step-id");
						var nextStep = $("#button-" + (parseInt(currentStepId) + 1));
						MoveBarTo(thisStepSlider, nextStep, true);
					} else {
						stepSliderBlock.find(".carousel-btn.carousel-next").trigger("click");
					}
				});

				prevButtons.on("click", function () {
					Bp = ZAGFramework.GetCurrentBP();
					if (!Bps.includes(Bp)) {
						var currentStepId = $(this).closest(".active-step").attr("data-step-id");
						var prevStep = $("#button-" + (parseInt(currentStepId) - 1));
						MoveBarTo(thisStepSlider, prevStep, true, true);
					} else {
						stepSliderBlock.find(".carousel-btn.carousel-prev").trigger("click");
					}
				});
			});
		}
	}
	function initMobile() {
		const stepSliderBlock = $(".block.block-step-slider");
		if (stepSliderBlock.length) {
			stepSliderBlock.each(function () {
				var thisStepSlider = $(this);

				const mobileCarousel = stepSliderBlock.find(".splide");

				if (mobileCarousel.length) {
					const splideCarousel = new Splide(mobileCarousel[0], {
						pagination: false,
						type: 'slide',
						fixedWidth: "100%",
						gap: "11px",
						speed: 600,
						drag: true,
						snap: false,
						perMove: 1,
						focus: 'center',
						trimSpace: false
					});

					const nextBtnMobile = stepSliderBlock.find(".carousel-btn.carousel-next");
					const prevBtnMobile = stepSliderBlock.find(".carousel-btn.carousel-prev");

					splideCarousel.on('mounted', function () {
						prevBtnMobile.addClass("disabled");
					});

					splideCarousel.mount();

					splideCarousel.on('move', function () {
						thisStepSlider.find(".carousel-btn.disabled").removeClass("disabled");
						var splideController = splideCarousel.Components.Controller;
						if (splideController.getIndex() == splideController.getEnd()) {
							nextBtnMobile.addClass("disabled");
						}
						if (splideController.getIndex() == 0) {
							prevBtnMobile.addClass("disabled");
						}
					});

					nextBtnMobile.on("click", function () {
						if (splideCarousel.Components.Controller.getNext() >= 0) {
							splideCarousel.go('+1')

							var currentStepId = $(".active-step").attr("data-step-id");
							var nextStep = $("#button-" + (parseInt(currentStepId) + 1));
							MoveBarTo(thisStepSlider, nextStep, true);
						}
					});

					prevBtnMobile.on("click", function () {
						if (splideCarousel.Components.Controller.getPrev() >= 0) {
							splideCarousel.go('-1')

							var currentStepId = $(".active-step").attr("data-step-id");
							var prevStep = $("#button-" + (parseInt(currentStepId) - 1));
							MoveBarTo(thisStepSlider, prevStep, true);
						}
					});

					//indicate correct step on mobile breakpoint transition
					var wasMobile = Bps.includes(Bp);
					$(window).on("resize", function () {
						Bp = ZAGFramework.GetCurrentBP();
						if (Bps.includes(Bp)) {
							if (!wasMobile) {
								MoveBarTo(thisStepSlider, $(".step.active-step"));
								var currentStepId = $(".active-step").attr("data-step-id");
								splideCarousel.go(parseInt(currentStepId) - 1);
							}
							wasMobile = true;
						} else {
							if (wasMobile) {
								MoveBarTo(thisStepSlider, $(".step.active-step"));
							}
							wasMobile = false;
						}
					});
				}
			});
		}
	}

	function MoveBarTo(thisStepSlider, step, scroll = false, back = false) {

		var stepButtons = thisStepSlider.find(".steps .step");
		var stepContents = thisStepSlider.find(".step-content");
		stepButtons.removeClass(activeClass).removeClass(completedClass);
		stepContents.removeClass(activeClass);

		var stepId = step.attr("data-step-id");
		$("#button-" + stepId).addClass(activeClass);
		$("#mobile-button-" + stepId).addClass(activeClass);
		$("#step-slider-" + stepId).addClass(activeClass);

		if (back) {
			$("#step-slider-" + stepId).find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).focus();
		}

		if (scroll) {
			$('html, body').animate({
				scrollTop: thisStepSlider.offset().top
			}, 100);
		}

		var redBar = thisStepSlider.find(".progress-bar .red-bar.desktop");
		var barStart = redBar.offset().left;
		redBar.css("max-width", step.find(".icon").offset().left - barStart);
		$("#button-" + stepId).prevAll().addClass(completedClass);

		var stepLabel = $("#step-slider-" + stepId).find(".step-content-header .step-label");
		if (stepLabel.length) {
			var stepText = stepLabel.text();
			stepLabel.text("");
			setTimeout(() => {
				stepLabel.text(stepText);
			}, "50");
		}
	}


	return {
		init,
		initMobile
	};

})(jQuery);

$(function () {
	App.StepSlider.init();
	App.StepSlider.initMobile();
});